<template>
  <custom-api-select
    :api="customerManage.getCustomerList"
    :api-params="apiParams"
    :immediate="true"
    value-field="id"
    label-field="name"
    :zero-to-undefined="true"
  />
</template>
<script lang="ts" setup>
import { customerManage } from '@/api/customer'
import { companyApiSelectProps } from './props'
const props = defineProps(companyApiSelectProps)
const { apiParams } = props
</script>
